// Individual profile mapping for combined strength titles
import { RankedMetric } from '../types/feedback'

export const INDIVIDUAL_PROFILE_LABELS: Record<string, { topStrength: string; secondStrength: string }> = {
  playerSharedResource: { topStrength: 'Resourceful', secondStrength: 'Enabler' },
  playerSharedAbility: { topStrength: 'Expert', secondStrength: 'Partner' },
  playerSharedItem: { topStrength: 'Generous', secondStrength: 'Provider' },
  initiatedPathTogetherEvent: { topStrength: 'Collaborative', secondStrength: 'Pathfinder' },
  timeAtMap: { topStrength: 'Aware', secondStrength: 'Navigator' },
  playerAirtimeTotal: { topStrength: 'Communicative', secondStrength: 'Participant' },
  solvedDronePuzzle: { topStrength: 'Analytical', secondStrength: 'Problem Solver' },
  timesPlayerResquedAnotherPlayerWithDrone: { topStrength: 'Supportive', secondStrength: 'Responder' },
  playerAirtimePrePlanning: { topStrength: 'Constructive', secondStrength: 'Planner' },
  playerAirtimeExecution: { topStrength: 'Concise', secondStrength: 'Communicator' },
  playerAirtimeEvaluation: { topStrength: 'Reflective', secondStrength: 'Evaluator' },
  playerAirtimeRelativeTotal: { topStrength: 'Balanced', secondStrength: 'Participant' },
  playerAirtimeRelativePrePlanning: { topStrength: 'Inclusive', secondStrength: 'Planner' },
  playerAirtimeRelativeExecution: { topStrength: 'Inclusive', secondStrength: 'Coordinator' },
  playerAirtimeRelativeEvaluation: { topStrength: 'Inclusive', secondStrength: 'Evaluator' },
  playerTimesTalkedTotal: { topStrength: 'Engaged', secondStrength: 'Contributor' },
  playerTimesTalkedPrePlanning: { topStrength: 'Proactive', secondStrength: 'Contributor' },
  playerTimesTalkedPreplanning: { topStrength: 'Proactive', secondStrength: 'Contributor' },
  playerTimesTalkedExecution: { topStrength: 'Responsive', secondStrength: 'Communicator' },
  playerTimesTalkedEvaluation: { topStrength: 'Insightful', secondStrength: 'Reviewer' },
  playerOverlapAirtimeTimesTotal: { topStrength: 'Respectful', secondStrength: 'Listener' },
  playerOverlapAirtimeTimesPrePlanning: { topStrength: 'Considerate', secondStrength: 'Planner' },
  playerOverlapAirtimeTimesPreplanning: { topStrength: 'Considerate', secondStrength: 'Planner' }, // Backend lowercase variant
  playerOverlapAirtimeTimesExecution: { topStrength: 'Disciplined', secondStrength: 'Communicator' },
  playerOverlapAirtimeTimesEvaluation: { topStrength: 'Considerate', secondStrength: 'Moderator' },
  oxygenEfficiency: { topStrength: 'Efficient', secondStrength: 'Operator' },
  informReport: { topStrength: 'Clear', secondStrength: 'Reporter' },
  receipt: { topStrength: 'Reliable', secondStrength: 'Responder' },
  agreeSupport: { topStrength: 'Supportive', secondStrength: 'Advocate' },
  disagreeChallengeIssue: { topStrength: 'Constructive', secondStrength: 'Challenger' },
  delegateAssign: { topStrength: 'Clear', secondStrength: 'Delegator' },
  offerHelp: { topStrength: 'Proactive', secondStrength: 'Supporter' },
  invite: { topStrength: 'Inclusive', secondStrength: 'Invitor' },
  roleTalk: { topStrength: 'Clarifying', secondStrength: 'Partner' },
  admitMistake: { topStrength: 'Accountable', secondStrength: 'Teammate' },
  thank: { topStrength: 'Appreciative', secondStrength: 'Colleague' },
  constructiveFeedback: { topStrength: 'Constructive', secondStrength: 'Coach' },
  goalOrientation: { topStrength: 'Outcome-focused', secondStrength: 'Contributor' }
}

/**
 * Generates combined individual title from top 2 metrics
 * Example: "Resourceful Enabler", "Aspiring leader"
 */
export function generateIndividualTitle(topMetrics: RankedMetric[]): string {
  if (topMetrics.length < 2) return 'Individual'

  const metric1 = topMetrics[0]
  const metric2 = topMetrics[1]

  const topStrength = INDIVIDUAL_PROFILE_LABELS[metric1.metric]?.topStrength || 'Strong'
  const secondStrength = INDIVIDUAL_PROFILE_LABELS[metric2.metric]?.secondStrength || 'Performer'

  return `${topStrength} ${secondStrength}`
}
